type TextEditorProps = {
  className?: string;
  content: string;
  updateContent: (content: string) => void;
};

export const TextEditor = ({
  className = '',
  content,
  updateContent,
}: TextEditorProps) => {
  return (
    <textarea
      className={`form-control form-control-solid ${className}`}
      value={content ?? ''}
      onChange={(e) => updateContent(e.target.value)}
      rows={6}
    />
  );
};
